import { ListToolbarContext } from "./list-toolbar.context";
import type { ListToolbarProps } from "./types-list-toolbar";
import { useListToolbar } from "./use-list-toolbar";
import { ListToolbarView } from "./view-list-toolbar";

export function ListToolbarRoot({ children, ...options }: ListToolbarProps) {
  const viewModel = useListToolbar(options, children);

  return (
    <ListToolbarContext.Provider value={viewModel.context}>
      <ListToolbarView
        ariaLabel={viewModel.ariaLabel}
        className={viewModel.className}
        style={viewModel.style}
        framed={viewModel.framed}
        testId={viewModel.testId}
        start={viewModel.start}
        end={viewModel.end}
        rest={viewModel.rest}
      />
    </ListToolbarContext.Provider>
  );
}
ListToolbarRoot.displayName = "ListToolbar.Root";
